import { stringifyAuthoringJSON } from "./authoring-json.mjs";

export function citySubjectResult(value) {
 if(!value || !["preview","queued","existing","manual_review"].includes(value.state))return null;
 const result=value.result,materials=result?.materials,source=materials?.source;
 if(!source || typeof source.nativeImplementationDigest!=="string" || !source.nativeImplementationDigest.startsWith("sha256:"))return null;
 const check=materials.c4_verify;
 const document=check?.correctedDocument || materials.c3_synthesis;
 const downloadable=document && typeof document==="object" && Array.isArray(document.cities) && document.cities.length===1;
 const blocking=Array.isArray(check?.blockingIssues)?check.blockingIssues.filter(note=>typeof note==="string"):[];
 const notes=blocking.length?blocking:Array.isArray(check?.reviewNotes)?check.reviewNotes.filter(note=>typeof note==="string"):[];
 const cityName=downloadable&&typeof document.cities[0]?.name==="string"?document.cities[0].name:"Город";
 return {state:value.state,document:downloadable?stringifyAuthoringJSON(document):null,notes,cityName,jobNumber:result.nativeJobNumber};
}
